import React from 'react';
function MoveUp({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M12 18L12 9" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 6L19 6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 13L12 9L8 13" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default MoveUp;
